export const OPEN_SPINNER_PROGRESS = "OPEN_SPINNER_PROGRESS";
export const CLOSE_SPINNER_PROGRESS = "CLOSE_SPINNER_PROGRESS";
